export enum SortPriorityEnum {
  Lowest,
  Low,
  High,
  Highest,
}
